import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterPipe } from './filter.pipe';
import { CurrencyCustomPipe } from './currency-custom.pipe';



@NgModule({
  declarations: [
    FilterPipe,
    CurrencyCustomPipe
  ],
  exports: [
    FilterPipe,
    CurrencyCustomPipe
  ],
  imports: [
    CommonModule
  ]
})
export class PipeModule { }
